import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';
import { Outlet, useOutletContext } from 'react-router';

import { SearchLayoutRoot } from '@sorare/core/src/components/search/SearchLayout/ui';
import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { getNbDecks } from '#src/lib/getNbDecks.ts';

import type {
  MyCardsCardsLayoutQuery,
  MyCardsCardsLayoutQueryVariables,
} from './__generated__/index.graphql.ts';

const MY_CARDS_CARDS_LAYOUT_QUERY = gql`
  query MyCardsCardsLayoutQuery($sport: Sport!) {
    currentUser {
      slug
      ...getNbDecks_publicUserInfoInterface
    }
  }
  ${getNbDecks.fragments.publicUserInfoInterface}
` as TypedDocumentNode<
  MyCardsCardsLayoutQuery,
  MyCardsCardsLayoutQueryVariables
>;

type LayoutData = {
  nbDecks: number;
};

export const useLayoutData = () => {
  const outletContext = useOutletContext();
  return outletContext as LayoutData;
};

export const loader = queryLoader(MY_CARDS_CARDS_LAYOUT_QUERY, ({ sport }) => ({
  sport,
}));

export const MyCardsCardsLayout = () => {
  const { data } = useQueryLoader<MyCardsCardsLayoutQuery>();
  return (
    <SearchLayoutRoot>
      <Outlet
        context={
          {
            nbDecks: getNbDecks(data.currentUser),
          } satisfies LayoutData
        }
      />
    </SearchLayoutRoot>
  );
};
